<div class="share-buttons" *ngIf="!!codeToShare">
    <!-- <button class="share" (click)="toggle()" [ngClass]="{ 'share--opened': (isApp || mobileSize) && openIcons }">
        <i class="icon-edponline-Bop-088" aria-hidden="true"></i>
        <img src="assets/images/moeda-zs.svg" alt="z" />
    </button> -->

    <div class="share-container share-container--app open" *ngIf="isApp; else socialWeb">

        <button class="social-icon" (click)="shareApp('facebook')">
            <i class="icon-edponline-Soc-002 icon"></i>
        </button>

        <!-- MESSENGER -->
        <button class="social-icon" (click)="shareApp('messenger')">
            <i class="icon-edponline-Sba-008 icon"></i>
        </button>

        <button class="social-icon" (click)="shareApp('whatsapp')">
            <i class="icon-edponline-whats-app icon"></i>
        </button>

        <button class="social-icon" (click)="shareApp('native')">
            <i class="icon-edponline-Bop-088 icon"></i> 
        </button>
    </div>

    <ng-template #socialWeb>
        <div class="share-container open" [ngClass]="{ 'share-container--app': mobileSize }">

            <button class="social-icon" mat-fab shareButton="facebook" #fbBtn="shareButton" [url]="urlToShare + '&socialMideaType=facebook'" (click)="share('facebook')">
                <i class="icon-edponline-Soc-002 icon"></i>
            </button>

            <button class="social-icon" mat-fab shareButton="twitter" #twtBtn="shareButton" [url]="urlToShare + '&socialMideaType=twitter'" (click)="share('twitter')">
                <i class="icon-edponline-Soc-001 icon"></i>
            </button>

            <button class="social-icon" mat-fab shareButton="linkedin" #wsBtn="shareButton" [url]="urlToShare + '&socialMideaType=linkedin'" (click)="share('linkedin')">
                <i class="icon-edponline-Soc-003 icon"></i>
            </button>

            <button class="social-icon" (click)="share('email')">
                <i class="icon-edponline-Bas-003 icon"></i>
            </button>
        </div>
    </ng-template>
</div>
